import { provideHttpClient } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  isDevMode,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, TitleStrategy, withComponentInputBinding, withHashLocation, withInMemoryScrolling } from '@angular/router';
import { provideToastr } from 'ngx-toastr';
import { provideVioTableV2 } from 'vio-tables-v2';
import { LOG_LEVELS, provideVwAppServices } from 'vwappservices';
import { routes } from './app.routes';
import { API } from './services/api-endpoints.constants';
import { AppTitleStrategy } from './services/app-title.strategy';
import { AuthService } from './services/auth.service';
import { LOCAL_API_URL } from './services/configuration.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    // zone.js keeps change detection compatible with vwappservices / vio-* libraries added later.
    provideZoneChangeDetection({ eventCoalescing: true }),
    // Hash URLs (#/dashboard): the backend token check matches API paths with url.includes(),
    // so deep links must never reach Express as real paths.
    provideRouter(routes, withHashLocation(), withComponentInputBinding(), withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    { provide: TitleStrategy, useExisting: AppTitleStrategy },
    provideHttpClient(),
    provideToastr({
      timeOut: 4000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      progressBar: true,
      closeButton: true,
      newestOnTop: true,
    }),
    // Shared defaults for every <vio-table-v2>; a table's own [tableConfig] wins.
    provideVioTableV2({
      initialPageSize: 10,
      dateDisplayFormat: 'dd MMM yyyy',
      showFormulaButton: false,
      showSummationButton: false,
      showHeaderGroupButton: false,
      actionColumnName: 'Actions',
    }),
    // baseUrl is only used on localhost; elsewhere vwappservices calls location.origin.
    provideVwAppServices({
      config: {
        baseUrl: LOCAL_API_URL,
        deviceType: 'W',
        authRefreshUrl: API.AUTH.REFRESH,
        logLevel: isDevMode() ? LOG_LEVELS.WARNING : LOG_LEVELS.NONE,
      },
    }),
    provideAppInitializer(async () => {
      const auth = inject(AuthService);
      auth.registerUnauthorisedHandler();
      await auth.restoreSession();
    }),
  ],
};
